import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Container } from 'react-bootstrap';
import Footer from '../components/Footer';
import HeaderLocation from '../components/Header';
import RecipeCard from '../components/RecipeCard';

const MAX_CATEGORIES = 5;
const MAX_CARDS = 12;

class Comidas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCategory: [],
      categoryName: '',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(category) {
    const { meals: mealsObj } = this.props;
    const { meals, Beef, Breakfast, Chicken, Dessert, Goat } = mealsObj || {};
    const { categoryName } = this.state;
    if (category !== categoryName && category !== 'All') {
      this.setState({ categoryName: category });
      switch (category) {
      case 'Beef':
        if (Beef && Beef.length > 0) {
          this.setState({ selectedCategory: Beef });
        } else {
          fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.meals || [] }));
        }
        break;
      case 'Breakfast':
        if (Breakfast && Breakfast.length > 0) {
          this.setState({ selectedCategory: Breakfast });
        } else {
          fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.meals || [] }));
        }
        break;
      case 'Chicken':
        if (Chicken && Chicken.length > 0) {
          this.setState({ selectedCategory: Chicken });
        } else {
          fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.meals || [] }));
        }
        break;
      case 'Dessert':
        if (Dessert && Dessert.length > 0) {
          this.setState({ selectedCategory: Dessert });
        } else {
          fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.meals || [] }));
        }
        break;
      case 'Goat':
        if (Goat && Goat.length > 0) {
          this.setState({ selectedCategory: Goat });
        } else {
          fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.meals || [] }));
        }
        break;
      default:
        fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
          .then((res) => res.json())
          .then((data) => this.setState({ selectedCategory: data.meals || [] }))
          .catch(() => this.setState({ selectedCategory: meals || [] }));
        break;
      }
    } else {
      this.setState({ categoryName: '', selectedCategory: null });
    }
  }

  render() {
    const { categories, meals: mealsProp } = this.props;
    const recipesCategories = (categories && Array.isArray(categories.recipesCategories)) ? categories.recipesCategories : [];
    const meals = (mealsProp && Array.isArray(mealsProp.meals)) ? mealsProp.meals : [];
    const { selectedCategory, categoryName } = this.state;
    const rawList = (!selectedCategory || !Array.isArray(selectedCategory) || selectedCategory.length === 0) ? meals : selectedCategory;
    const listToRender = Array.isArray(rawList) ? rawList : [];

    return (
      <div className="page-wrapper-custom">
        <HeaderLocation />
        <Container>
          <div className="categories-filter-wrapper">
            <Button
              size="sm"
              className={`filter-button orange ${categoryName === '' || categoryName === 'All' ? 'active' : ''}`}
              type="button"
              onClick={ (event) => this.handleClick(event.target.name) }
              name="All"
              data-testid="All-category-filter"
            >
              ✨ Todos
            </Button>
            {
              recipesCategories.map((category, index) => {
                if (index < MAX_CATEGORIES) {
                  return (
                    <Button
                      size="sm"
                      className={`filter-button orange ${categoryName === category.strCategory ? 'active' : ''}`}
                      key={ index }
                      type="button"
                      onClick={ () => this.handleClick(category.strCategory) }
                      data-testid={ `${category.strCategory}-category-filter` }
                    >
                      {category.strCategory}
                    </Button>
                  );
                }
                return null;
              })
            }
          </div>

          <div className="recipes-grid-custom">
            {
              listToRender.map((meal, index) => {
                if (index < MAX_CARDS && meal) {
                  return (
                    <Link
                      key={ meal.idMeal || index }
                      className="recipe-link"
                      to={ `/comidas/${meal.idMeal}` }
                    >
                      <RecipeCard
                        idRecipeCard={ `${index}-recipe-card` }
                        idImg={ `${index}-card-img` }
                        srcImg={ meal.strMealThumb }
                        idCardName={ `${index}-card-name` }
                        mealName={ meal.strMeal }
                      />
                    </Link>
                  );
                }
                return null;
              })
            }
          </div>
        </Container>
        <Footer className="footer orange" />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories,
  meals: state.meals,
});

Comidas.propTypes = {
  meals: PropTypes.objectOf(Object).isRequired,
  categories: PropTypes.objectOf(Object).isRequired,
};

export default connect(mapStateToProps)(Comidas);

